import { computed } from '@vue/composition-api'
import useRequest from '@/compositions/useRequest'

export default ({
  props: {
    item: Object,
    offer: Object,
  },
  setup(props, context) {
    const { $store } = context.root
    const { emit } = context
    const isCash = computed(() => props.item.payment === 'cash')
    const price = computed(() => ((props.offer?.price % 1) ? parseFloat(props.offer?.price).toFixed(1) : Math.round(props.offer?.price)))

    const acceptRequest = useRequest({
      context,
      request: () => $store.dispatch('materialDeliveries/acceptOffer', { id: props.offer.id }),
      successMessage: 'Заявка принята!',
    })

    const rejectRequest = useRequest({
      context,
      request: () => $store.dispatch('materialDeliveries/rejectOffer', { id: props.offer.id }),
      successMessage: 'Заявка отклонена!',
    })

    const accept = async () => {
      await acceptRequest.makeRequest()
      emit('update')
    }

    const reject = async () => {
      await rejectRequest.makeRequest()
      emit('update')
    }


    return {
      isCash,
      price,
      loadingAccept: computed(() => acceptRequest.loading.value),
      loadingReject: computed(() => rejectRequest.loading.value),
      accept,
      reject,
    }
  },
})
